import "./Tela03.styles.css";
import { useState } from "react";

import bgTl3 from "../../img/imgsTela3/bgTl3.png";
import pessoa1 from "../../img/imgsTela3/pessoa1.png";
import pessoa2 from "../../img/imgsTela3/pessoa2.jpeg";
import pessoa3 from "../../img/imgsTela3/pessoa3.jpeg";

import capaVideo1 from "../../img/imgsTela3/video1.png";

export default function Tela3(){

    const [videoAberto, setVideoAberto] = useState(null);

    const vencedores = [
        {
        id: 1,
        lugar: "1º Lugar",
        nome: "Danielle Guimarães",
        unidade: "SENAI SUDESTE",
        nota: "95,33",
        foto: pessoa1,
        thumb: capaVideo1,
        videoUrl: "https://www.youtube.com/embed/TWhEfIO-iJc?si=k0ZU3iaX4ykoAXfa",
        descricao:
            "A professora Danielle buscou em sua aplicação Inovaê Docente conectar teoria, prática e realidade industrial. Com a gamificação Eu Já versus Eu Nunca para identificar conhecimentos prévios, na sequência, os alunos fizeram um tour virtual à fábrica da Faber Castell para observarem os processos produtivos, fluxo e organização de trabalho. Associou aula dialogada e um curso do Senai Play sobre eficiência e eficácia. Finalizou com uma SA, na estratégia de aprendizagem estudo de caso.",
        },
        {
        id: 2,
        lugar: "2º Lugar",
        nome: "Herberth Vilaronga",
        unidade: "SENAI JUAZEIRO",
        nota: "94,67",
        foto: pessoa2,
        thumb: capaVideo1,
        videoUrl: "https://www.youtube.com/embed/Peh5UlSdLi0?si=V2SH_bJukybILv6V",
        descricao:
            "O professor Herberth, na UC de Metrologia, utilizou IA para criar um jogo de tabuleiro, abordando a leitura do instrumento paquímetro. Inspirado na saga Game of Trones criou o Game of Metrology, cada equipe se transformou numa família da saga e a partir da leitura de um paquímetro digital foram atravessando 40 etapas rumo a aprendizagem engajada e significativa.",
        },
        {
        id: 3,
        lugar: "3º Lugar",
        nome: "Fábio Costa",
        unidade: "SENAI LAURO DE FREITAS",
        nota: "90,67",
        foto: pessoa3,
        thumb: capaVideo1,
        videoUrl: "https://www.youtube.com/embed/NK0MvsgRXHA?si=X7dtUWYJPxzOKzAJ",
        descricao:
            "Com o professor Fábio seus alunos de Interface Homem-Computador puderam vivenciar uma gamificação por meio do jogo das plaquinhas para internalizar as 10 Heurísticas de Jacob Nielsen. Para tanto utilizou computador, smartphone, placas com QR Codes impressos e o Plickers, uma ferramenta educacional gratuita que permite que o docente escanei as repostas dos alunos, gerando gráficos com os resultados obtidos pela turma.",
        },
    ];

    return(


        <section className="tela03" style={{ backgroundImage: `url(${bgTl3})` }}>

            <div className="tela03__container">

                {vencedores.map((item) => (
                        <article className="card_vencedor" key={item.id} id={`vencedor-${item.id}`}>
                            <div className="card_vencedor__lado">
                                <img
                                    src={item.foto}
                                    alt={item.nome}
                                    className="card_vencedor__foto"
                                />

                                <div className="card_vencedor__info">
                                    <h3>{item.lugar}</h3>
                                    <p className="nome">{item.nome}</p>
                                    <p className="unidade">{item.unidade}</p>
                                    <span className="nota">{item.nota}</span>
                                </div>
                            </div>

                            <div className="card_vencedor__videoBox">
                            <img
                                src={item.thumb}
                                alt={`Thumbnail de ${item.nome}`}
                                className="card_vencedor__video"
                            />

                            <button
                                className="card_vencedor__play"
                                aria-label={`Reproduzir vídeo de ${item.nome}`}
                                onClick={() => setVideoAberto(item)}
                            >
                                ▶
                            </button>
                            </div>

                            <div className="card_vencedor__texto">
                            <p>{item.descricao}</p>
                            </div>
                        </article>
                ))}

            </div>

            {videoAberto && (
                <div className="video_modal" onClick={() => setVideoAberto(null)}>
                    <div
                    className="video_modal__content"
                    onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="video_modal__close"
                            onClick={() => setVideoAberto(null)}
                            aria-label="Fechar vídeo"
                        >
                            ×
                        </button>

                        <div className="video_modal__iframeWrapper">
                            <iframe
                            src={`${videoAberto.videoUrl}&autoplay=1`}
                            title={`Vídeo de ${videoAberto.nome}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            )}

        </section>


    )


}